import Delegate from "//legramme.com/cdn/shop/t/43/assets/ftdomdelegate.min.js?v=167457923630348017651741950200";

export class FeaturedProducts404Section extends HTMLElement {
    connectedCallback() {

      this.allTabs          = this.querySelectorAll('[data-action="change-tab"]');
      this.allProductsTabs  = this.querySelectorAll('[data-action="products-tab"]');
  
      this._attachListeners();
    }
  
    _attachListeners() {
        new Delegate(this).on('click', '[data-action="change-tab"]', this._changeTab.bind(this));
    }
  
    _changeTab(event, target) {
      event.preventDefault();
  
      if (this.allTabs && this.allProductsTabs) {
        for (let i = 0; i < this.allTabs.length; i++) {
          this.allTabs[i].classList.remove('active');
          this.allProductsTabs[i].classList.remove('active');
        }
      }
  
      target.classList.add('active');
      this.querySelector('[data-action="products-tab"][data-tab="'+target.getAttribute('data-tab')+'"]').classList.add('active');
    }
  
}
try {
    window.customElements.define('page-not-found', FeaturedProducts404Section);
  } catch(e) {}